import {Box, FormControlLabel, Radio, SxProps, Typography} from '@mui/material';
import React, { useMemo } from 'react';
import {Control, Controller, FieldValues} from 'react-hook-form';

interface Props {
  control: Control<FieldValues>;
  name: string;
  options: Array<{
    value: string;
    label: string;
  }>;
  sx?: SxProps;
  radioSx?: SxProps;
}

const FormRadioGroup: React.FC<Props> = ({
  control,
  name,
  options,
  sx,
  radioSx,
}) => {
  const flexDirection = useMemo(
    () =>
      (radioSx as SxProps & {flexDirection?: 'row' | 'column'})
        ?.flexDirection ?? 'row',
    [radioSx],
  );
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...sx,
      }}>
      <Controller
        name={name}
        control={control}
        render={({field}) => (
          <Box sx={{display: 'flex', flexDirection, gap: 2}}>
            {options.map(option => (
              <FormControlLabel
                key={option.value}
                control={
                  <Radio
                    checked={field.value === option.value}
                    onClick={() => {
                      field.onChange(
                        field.value === option.value ? null : option.value,
                      );
                    }}
                  />
                }
                label={<Typography variant="body1">{option.label}</Typography>}
              />
            ))}
          </Box>
        )}
      />
    </Box>
  );
};

export default React.memo(FormRadioGroup);
